import { render, staticRenderFns } from "./CellDtLinkType.vue?vue&type=template&id=8bc3a4f2&scoped=true"
import script from "./CellDtLinkType.vue?vue&type=script&lang=js"
export * from "./CellDtLinkType.vue?vue&type=script&lang=js"
import style0 from "./CellDtLinkType.vue?vue&type=style&index=0&id=8bc3a4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc3a4f2",
  null
  
)

export default component.exports